import React, { useEffect, useRef } from 'react';
import './ReminderOverlay.css';

interface ReminderOverlayProps {
  onClose: () => void;
  setShowReminder?: (v: boolean) => void; // 알림 제어용 (옵션)
}

// 한국시간 Date 객체 반환
function getKoreaDate() {
  const now = new Date();
  const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
  return new Date(utc + (9 * 60 * 60 * 1000));
}

const ReminderOverlay: React.FC<ReminderOverlayProps> = ({ onClose, setShowReminder }) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // 다음 정시까지 남은 ms 계산
    const koreaNow = getKoreaDate();
    const nextHour = new Date(koreaNow);
    nextHour.setMinutes(0, 0, 0);
    nextHour.setHours(koreaNow.getHours() + 1);
    const msToNextHour = nextHour.getTime() - koreaNow.getTime();

    // 다음 정시에 알람 띄우기
    timeoutRef.current = setTimeout(() => {
      setShowReminder && setShowReminder(true);
      // 이후 1시간마다 반복
      intervalRef.current = setInterval(() => {
        setShowReminder && setShowReminder(true);
      }, 60 * 60 * 1000);
    }, msToNextHour);

    // 언마운트 시 timeout, interval 모두 해제
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [setShowReminder]);

  return (
    <div className="reminder-overlay">
      <div className="reminder-content">
        <h2 className="reminder-title">
          ⚠️ 주의! 깜빡한 오더 체크
        </h2>
        
        <div className="reminder-message">
          <p>
            한 시간이 지났습니다.
          </p>
          <p>
            깜빡한 오더는 없나요?
          </p>
          <p>
            다시 한번 오더를 체크해보세요!
          </p>
        </div>

        <button
          onClick={onClose}
          className="reminder-button"
        >
          확인했습니다
        </button>
      </div>
    </div>
  );
};

export default ReminderOverlay; 